import { useMemo } from 'react';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { Filter, useFilterConfig } from './useFilterConfig';

export type AppliedFilter = Filter & {
  values: string[];
};

export function useAppliedFilters() {
  const params = useSearchParams();
  const filterConfig = useFilterConfig();

  return useMemo(() => {
    const appliedFilters: AppliedFilter[] = [];

    // pull `error` and `loading` out, so we only have actual filters left
    const { error: __error, loading: __loading, ...filters } = filterConfig;

    for (const filter of Object.values(filters)) {
      if (!filter) continue;

      const paramValues = params.getList(filter.field);
      if (paramValues.length === 0) continue;

      appliedFilters.push({
        ...filter,
        values: paramValues,
      });
    }

    return appliedFilters;
  }, [filterConfig, params]);
}
